export default "__VITE_ASSET__CnXNSEZS__"